module.exports = __webpack_public_path__ + "img/orange_131.a2007a70.png";